import React, {useState, useEffect} from 'react'
import styled, { keyframes } from 'styled-components';
import { RiArrowDownSLine } from 'react-icons/ri';
import { RiArrowRightSLine } from 'react-icons/ri';
import SEO from '../components/SEO';

interface Prop{
    history?: any;
    q: string;
    a: any;
}

const QuestionComp:React.FC<Prop> = ({q, a}) => {
    const [show, setshow] = useState(false);
    return(
        <Column style={{padding: "10px 0"}}>
        <QuestionContainer onClick={()=>setshow(!show)}>
            {
            show?
                <ArrowDown>
                    <RiArrowRightSLine fontSize={"22px"} color={"#28559A"}/>
                </ArrowDown>
                :
                <ArrowRight>
                    <RiArrowRightSLine fontSize={"22px"} color={"#28559A"}/>
                </ArrowRight>
            }
            <Question>{q}</Question>
        </QuestionContainer>
        {
            show?
        <QuestionContainer>
            <Answer>
                {a}
            </Answer>
        </QuestionContainer>
        :<></>
        }

        </Column>
    )
}


const FAQs : React.FC<Prop>=({})=>{

    const howtouse = () => {
        return(
            <>
                To use MiAmigo.ai chatbot <ol><li>Register an account</li><li>Choose your subscription level</li><li>Add javascript to your webpage to launch the chatbot</li></ol>
            </>
        )
    }

    const getSublevels = () => {
        return (
            <>
                There are 3 levels of subscription<ul><li>Basic: Free</li><li>Preferred: $10/month</li><li>Premium: $20/month</li></ul>
            </>
        )
    }

    const faqs = [
        { q: "What is MiAmigo.ai?", a: "MiAmigo.ai is an AI chat assistant plugin that can be added to any website in minutes! It answers your customers' questions using your own website content, not generic guesses." },
        { q: "How to use MiAmigo chatbot?", a: howtouse(), plain: "Register an account, choose your subscription level, then add a small snippet of JavaScript to your webpage to launch the chatbot." },
        { q: "What does subscription to MiAmigo chatbot cost?", a: getSublevels(), plain: "There are 3 levels of subscription: Basic (Free), Preferred ($10/month), and Premium ($20/month)." },
        { q: "How does the chatbot know what to say about my business?", a: "It's built directly from your own website content - your pages, policies, and pricing. You can also add or edit specific answers yourself from your dashboard at any time." },
        { q: "Will the chatbot make up answers it doesn't actually know?", a: "No. The chatbot only answers using the content it has for your business, and is designed to say plainly when it doesn't have the information rather than guess - so it won't invent pricing, policies, or details that aren't real." },
        { q: "Do I need any coding experience to set it up?", a: "No. Setup is a short web-based flow, and adding the chatbot to your site is a single snippet of code you paste in, the same way you would add Google Analytics." },
        { q: "Can I update what the chatbot knows after it's live?", a: "Yes. You can add, edit, or remove information from your dashboard at any time, and the chatbot's answers reflect those changes immediately - there's no retraining delay." },
        { q: "Is my website content shared with other businesses' chatbots?", a: "No. Each business's content and chatbot answers are kept separate and are only used to answer questions about that business." },
    ]

    const faqJsonLd = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": faqs.map((item) => ({
            "@type": "Question",
            "name": item.q,
            "acceptedAnswer": {
                "@type": "Answer",
                "text": item.plain || item.a,
            },
        })),
    }

  return(
    <MainContainer>
        <SEO
            title="Frequently Asked Questions | MiAmigo.AI"
            description="Answers to common questions about MiAmigo.ai's AI chatbot: setup, pricing, accuracy, and how it's trained on your own website content."
            path="/frequently-asked-questions"
            jsonLd={faqJsonLd}
        />
        <Column>
            <Header>Frequently Asked Questions</Header>
            {faqs.map((item) => (
                <QuestionComp key={item.q} q={item.q} a={item.a} />
            ))}
        </Column>

    </MainContainer>
  );
}

const showAnimation = keyframes`
0% {
    opacity: 0
  }
  50% {
    opacity: 0.5
  }
  100% {
    opacity: 1;
  }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(90deg);
  }
}`;

const MainContainer = styled.div`
display: flex;
min-height: 85vh;
justify-content: center;
align-items: flex-start;
padding: 50px;
color: #ffffff;
@media(max-width: 900px){
  flex-direction: column-reverse;
  align-items: center;
}
`

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`

const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin: 5px;
`

const Column = styled.div`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  color: #ffffff;
  @media (max-width: 900px) {
	padding: 20px;
  }
`

const Header = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 40px;
    justify-content: flex-end;
    color: black;
`;

const QuestionContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: black;
    animation: ${showAnimation} 0.5s linear;
`;

const Question = styled.div`
    font-weight: 400;
    font-size: 18px;
    justify-content: flex-end;
    color: black;
    cursor: pointer;
`;
const ArrowRight =styled.div`
  width: 20px;
`;
const ArrowDown =styled.div`
    width: 20px;
    opacity: 1;
    transform: rotate(90deg);
    animation: ${spin} 0.25s linear;
`;
const Answer = styled.div`
    margin: 10px 0 0 0;
    padding: 0px 20px;
    font-weight: 400;
    font-size: 15px;
    justify-content: flex-end;
    line-height: 2;
    color: black;
`;

const OrderedList = styled.ol`
    margin: 10px 0 0 0;
    padding: 0px 20px;
`;

const List = styled.li`
    margin: 0px;
    font-weight: 400;
    font-size: 15px;
    color: black;
`;

export default FAQs